import React, { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TrustedLogos = () => {
  const { t } = useTranslation();
  // Data arrays for logos
  const topRowLogos = useMemo(
    () => [
      '/assets/trusted-1.svg',
      '/assets/trusted-2.svg',
      '/assets/trusted-3.svg',
      '/assets/trusted-4.svg',
      '/assets/trusted-5.svg',
    ],
    []
  );

  const bottomRowLogos = useMemo(
    () => [
      '/assets/trusted-10.svg',
      '/assets/trusted-9.svg',
      '/assets/trusted-8.svg',
      '/assets/trusted-7.svg',
      '/assets/trusted-6.svg',
    ],
    []
  );

  const repeat = 3;
  const durationSec = 25;

  // Duplicate arrays for seamless loop
  const duplicatedTopLogos = useMemo(
    () => Array.from({ length: repeat }).flatMap(() => topRowLogos),
    [repeat, topRowLogos]
  );

  const duplicatedBottomLogos = useMemo(
    () => Array.from({ length: repeat }).flatMap(() => bottomRowLogos),
    [repeat, bottomRowLogos]
  );

  // Inject keyframes once
  useEffect(() => {
    const distance = ((repeat - 1) / repeat) * 100;
    const keyNameLeft = `marqueeLeft_r${repeat}`;
    const keyNameRight = `marqueeRight_r${repeat}`;

    const idLeft = `kf-${keyNameLeft}`;
    const idRight = `kf-${keyNameRight}`;

    if (!document.getElementById(idLeft)) {
      const style = document.createElement('style');
      style.id = idLeft;
      style.innerHTML = `@keyframes ${keyNameLeft} { 0% { transform: translateX(0); } 100% { transform: translateX(-${distance}%); } }`;
      document.head.appendChild(style);
    }

    if (!document.getElementById(idRight)) {
      const style = document.createElement('style');
      style.id = idRight;
      style.innerHTML = `@keyframes ${keyNameRight} { 0% { transform: translateX(-${distance}%); } 100% { transform: translateX(0); } }`;
      document.head.appendChild(style);
    }
  }, [repeat]);

  const keyNameLeft = `marqueeLeft_r${repeat}`;
  const keyNameRight = `marqueeRight_r${repeat}`;

  return (
    <div className="px-4 sm:px-6 xl:px-8 py-20 sm:py-[120px] bg-white">
      <div className="py-10 w-full">
        <h2 className="text-center text-[#021A0D] text-[24px] sm:text-[32px] leading-[40px] font-bold libre-baskerville">
          {t('home.trusted.title')}
        </h2>

        <div className="sm:mt-10 pt-10 max-w-[1204px] w-full mx-auto flex flex-col gap-[38px]">
          {/* Left to right continuous slider */}
          <div className="overflow-hidden">
            <div
              className="flex items-center"
              style={{
                width: `${repeat * 100}%`,
                animation: `${keyNameLeft} ${durationSec}s linear infinite`,
                willChange: 'transform',
              }}
            >
              {duplicatedTopLogos.map((logo, i) => (
                <div
                  key={`top-${i}`}
                  className="flex-shrink-0"
                  style={{
                    width: `${100 / (topRowLogos.length * repeat)}%`,
                    marginRight:
                      i < duplicatedTopLogos.length - 1 ? '50px' : '0px',
                  }}
                >
                  <img
                    src={logo}
                    alt="trusted"
                    className="h-auto w-auto max-w-full"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Right to left continuous slider */}
          <div className="overflow-hidden">
            <div
              className="flex items-center"
              style={{
                width: `${repeat * 100}%`,
                animation: `${keyNameRight} ${durationSec}s linear infinite`,
                willChange: 'transform',
              }}
            >
              {duplicatedBottomLogos.map((logo, i) => (
                <div
                  key={`bottom-${i}`}
                  className="flex-shrink-0"
                  style={{
                    width: `${100 / (bottomRowLogos.length * repeat)}%`,
                    marginRight:
                      i < duplicatedBottomLogos.length - 1 ? '60px' : '0px',
                  }}
                >
                  <img
                    src={logo}
                    alt="trusted"
                    className="h-auto w-auto max-w-full"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedLogos;
